import { Card, Col, TabContent } from "reactstrap";
import { DraftEmailData, PrivateEmailData, SentEmailData, SupportEmailData, TrashEmailData, WorkEmailData } from "../../../../data/applications/LetterBox";
import { useAppSelector } from "../../../../reduxToolkit/hooks";
import { EmailListProp } from "../../../../types/Applications";
import AddLabelModal from "./AddLabelModal";
import EmailContent from "./common/EmailContent";
import ComposeEmailModal from "./composeEmailModal";
import EmailHeader from "./emailHeader";
import Inbox from "./inbox";
import Starred from "./starred";
import InterviewMail from "./interviewMail";

const EmailList: React.FC<EmailListProp> = ({ navId }) => {
  const { interviewEmail } = useAppSelector((state) => state.letterBox);

  return (
    <Col xxl="9" xl="8" className="box-col-12">
      <div className="mail-right-bar">
        <Card className={`message-body email-list ${interviewEmail ? "hide" : "show"}`}>
          <ComposeEmailModal />
          <EmailHeader />
          <TabContent activeTab={navId} id="email-pills-tabContent">
            <Inbox />
            <EmailContent tableId={"2"} contentData={SentEmailData} />
            <Starred />
            <EmailContent tableId={"4"} contentData={DraftEmailData} />
            <EmailContent tableId={"5"} contentData={TrashEmailData} />
            <EmailContent tableId={"6"} contentData={WorkEmailData} />
            <EmailContent tableId={"7"} contentData={PrivateEmailData} />
            <EmailContent tableId={"8"} contentData={SupportEmailData} />
            <AddLabelModal />
          </TabContent>
        </Card>
        <InterviewMail />
      </div>
    </Col>
  );
};

export default EmailList;
